import { render } from "./DatadogForm.vue?vue&type=template&id=7af2e25b&ts=true"
import script from "./DatadogForm.vue?vue&type=script&lang=ts"
export * from "./DatadogForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__